module.exports = __webpack_public_path__ + "quilt1-level1.0feea98d.png";